import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRole } from './auth.models';
import { TokenService } from './token.service';

export function roleGuard(roles: UserRole[]): CanActivateFn {
  return () => {
    const tokenService = inject(TokenService);
    const router = inject(Router);
    const role = tokenService.role();

    if (role && roles.includes(role)) {
      return true;
    }

    return router.createUrlTree(['/dashboard']);
  };
}
